// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"466":"b845ac2a","648":"b845ac2a","793":"ab01f8c5","840":"2c90259a"}[chunkId] + ".chunk.css";
};